import styles from "./contact-card-reseller.module.less";

export type TContactCardReseller = {
  companyName?: string;
  streetAdress?: string;
  postalCode?: string;
  postalLocality?: string;
  phone?: string;
  websiteUrl?: string;
};

export const ContactCardReseller = ({
  companyName,
  streetAdress,
  postalCode,
  postalLocality,
  phone,
  websiteUrl,
}: TContactCardReseller) => {
  const postalCodeAndLocality = `${postalCode} ${postalLocality ? ", " + postalLocality : ""}`.trim();

  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.identificationSection}>
          <p className={[styles.name, "body-base bold mb-0"].join(" ")}>{companyName}</p>
          {streetAdress && <p className={[styles.addressLine, "body-s my-0"].join(" ")}>{streetAdress}</p>}
          {postalCodeAndLocality && (
            <p className={[styles.addressLine, "body-s my-0"].join(" ")}>{postalCodeAndLocality}</p>
          )}
        </div>
        <div className={styles.contactSection}>
          {websiteUrl && (
            <a href={websiteUrl} className={["body-s mb-0", styles.link].join(" ")}>
              {websiteUrl}
            </a>
          )}
          {phone && (
            <a href={`tel:${phone}`} className={["body-s mb-0", styles.link].join(" ")}>
              {phone}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export const ContactCardResellerContent = (props: TContactCardReseller) => {
  return (
    <div className={"space-my-sm"}>
      <ContactCardReseller {...props} />
    </div>
  );
};

export default ContactCardReseller;
